import store from '@/state/store'

export default [
    {
        path: '/portal-sso',
        name: 'portal-sso',
        component: () => import('../pages/auth/portalSso'),
        meta: {
            authRequired: false,
        },
    },
    {
        path: '/sso-login',
        name: 'sso-login',
        component: () => import('../pages/auth/ssoLogin'),
        meta: {
            authRequired: false,
        },
    },
    {
        path: '/dang-nhap',
        name: 'login',
        component: () => import('../pages/auth/auth'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                const loggeduser = localStorage.getItem('user-token');
                if (loggeduser) {
                    // Redirect to the home page instead
                    window.location.href = '/'
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('./views/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({
                        name: 'home'
                    })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({
                        name: 'home'
                    })
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? {
                    name: 'default'
                } : {
                    ...routeFrom
                })
            },
        },
    },
    {
        path: '/pages/404',
        name: 'Page-404',
        component: () => import('./views/pages/error-404'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/pages/500',
        name: 'Page-500',
        component: () => import('./views/pages/error-500'),
        meta: {
            authRequired: true,
        }
    },
    {
        path: '/',
        component: () => import('../layouts/main.vue'),
        children: [
            {
                path: '',
                meta: {
                    authRequired: true
                },
                name: 'home',
                component: () => import('../pages/dashboard/index'),
            },
            {
                path: "/van-ban-di",
                name: "Văn bản đi",
                // meta: {},
                component: () => import("../pages/vanbandi"),
            },
            {
                path: "/tat-ca-van-ban-di",
                name: "Văn bản đi",
                // meta: {},
                component: () => import("../pages/vanbandi/tatCaVanBanDi"),
            },
            {
                path: "/quan-ly-van-ban-di",
                name: "Quản lý văn bản đi",
                // meta: {},
                component: () => import("../pages/vanbandi/quanLyVanBanDi"),
            },
            {
                path: "/ban-hanh-van-ban",
                name: "Văn bản đi",
                // meta: {},
                component: () => import("../pages/vanbandi/banHanhVanBanDi"),
            },
            {
                path: "/xu-ly-van-ban-di",
                name: "Văn bản đi",
                // meta: {},
                component: () => import("../pages/vanbandi/xuLyVanBanDi"),
            },
            {
                path: "/cap-so-van-ban-di",
                name: " Cấp số văn bản đi",
                // meta: {},
                component: () => import("../pages/vanbandi/capSoVanBanDi"),
            },
            {
                path: '/linh-vuc',
                name: 'LinhVuc',
                component: () => import('../pages/linhvuc'),
                meta: {
                    authRequired: true,
                }
            },
            {
                path: "/nhom-quyen",
                name: "NhomQuyen",
                meta: {
                    authRequired: true,
                },
                component: () => import("../pages/module"),
            },
            {
                path: "/nhom-quyen/action/:id?",
                name: "Hành động",
                // meta: {},
                component: () => import("../pages/module/action"),
            },
            {
                path: "/menu",
                name: "Menu",
                meta: { authRequired: true, },
                component: () => import("../pages/menu"),
            },
            {
                path: "/vai-tro",
                name: "Quyền",
                meta: { can: 'viewpage-roles' },
                component: () => import("../pages/role"),
            },
            {
                path: "/vai-tro/thiet-lap-quyen/:id?",
                name: "Vai trò",
                meta: { can: 'viewpage-roles' },
                component: () => import("../pages/role/addPermissions01"),
            },
            {
                path: "/add-permissions",
                name: "Test ",
                component: () => import("../pages/role/addPermissions"),
            },
            {
                path: "/tai-khoan",
                name: "Tài khoản",
                meta: {
                    can: 'viewpage-user',
                },
                component: () => import("../pages/user"),
            },
            {
                path: "/tai-khoan/doi-mat-khau",
                name: "Đổi mật khẩu",
                meta: { can: 'viewpage-user', },
                component: () => import("../pages/user/ChangePass"),
            },
            {
                path: "/don-vi",
                name: "Đơn vị",
                meta: {},
                component: () => import("../pages/donVi"),
            },
            {
                path: "/loggings",
                name: "Loggings",
                meta: {},
                component: () => import("../pages/loggings"),
            },
            {
                path: "/thong-tin-ca-nhan",
                name: "Thông tin cá nhân",
                // meta: {},
                component: () => import("../pages/auth/profile"),
            },
            {
                path: "/chuc-vu",
                name: "Chức vụ",
                // meta: {},
                component: () => import("../pages/chucVu"),
            },
            {
                path: "/loai-van-ban",
                name: "Loại văn bản",
                component: () => import("../pages/loaiVanBan"),
            },
            {
                path: "/trang-thai",
                name: "Trạng thái",
                // meta: {},
                component: () => import("../pages/trangThai"),
            },
            {
                path: "/hinh-thuc-gui",
                name: "Hình thức gửi",
                // meta: {},
                component: () => import("../pages/hinhThucGui"),
            },
            {
                path: "/khoi-co-quan",
                name: "Khối cơ quan",
                // meta: {},
                component: () => import("../pages/khoiCoQuan"),
            },
            {
                path: "/co-quan",
                name: "Cơ quan",
                // meta: {},
                component: () => import("../pages/coQuan"),
            },
            {
                path: "/soan-van-ban-den/:id?",
                name: "soan-van-ban-den",
                //meta: { },
                component: () => import("../pages/vanbandenXL/soanVanBanDen"),
            },
            {
                path: "/van-ban-den",
                name: "Văn bản đến",
                //meta: { },
                component: () => import("../pages/vanbandenXL"),
            },
            {
                path: "/xu-ly-van-ban-den",
                name: "Văn bản đến",
                //meta: { },
                component: () => import("../pages/vanbandenXL/xuLyVanBanDen"),
            },
            {
                path: "/cap-so-van-ban-den",
                name: "Cấp số văn bản đến",
                //meta: { },
                component: () => import("../pages/vanbandenXL/capSoVanBanDen"),
            },
            {
                path: "/thong-bao-van-ban",
                name: " Thông báo van ban",
                // meta: {},
                component: () => import("../pages/thongBao/index"),
            },
            {
                path: "/thong-bao-chung",
                name: " Thông báo chung",
                // meta: {},
                component: () => import("../pages/thongBao/thongBaoChung"),
            }
            ,
            {
                path: "/ky-so",
                name: "Ký số",
                // meta: {},
                component: () => import("../pages/kyso"),
            },
            {
                path: "/loai-trang-thai",
                name: " Loại trạng thái",
                // meta: {},
                component: () => import("../pages/loaiTrangThai"),
            },
            {
                path: "/xac-nhan-ky-so-noi-bo",
                name: " Xác nhận ký số nội bộ",
                // meta: {},
                component: () => import("../pages/xacNhanKySo"),
            },
            {
                path: "/lich-cong-tac/:loaiLichCongTac",
                name: "Lịch công tác",
                // meta: {},
                component: () => import("../pages/lichcongtac/index"),
            },
            {
                path: "/lich-cong-tac-ca-nhan",
                name: "Lịch công tác cá nhân",
                // meta: {},
                component: () => import("../pages/lichcongtac/lichcongtaccanhan"),
            },
            {
                path: "/cong-viec/:id",
                name: "congviec",
                // meta: {},
                component: () => import("../pages/lichcongtac/danhSachCongViec"),
            },
            {
                path: "/sign-digital",
                name: "Lịch công tác",
                // meta: {},
                component: () => import("../pages/signDigital"),
            },
            {
                path: "/xem-lich-cong-tac/:loaiLichCongTac?",
                name: "Danh sách lịch công tác",
                // meta: {},
                component: () => import("../pages/lichcongtac/dsLichCongTac"),
            },
            {
                path: "/thu-den",
                name: "ThuDen",
                component: () => import("../pages/hopThu/index"),
            },
            {
                path: "/thu-da-gui",
                name: "ThuDaGui",
                component: () => import("../pages/hopThu/thuDaGui"),
            },
            {
                path: "/thu-rac",
                name: "ThuRac",
                component: () => import("../pages/hopThu/thuRac"),
            },
            {
                path: "/thiet-lap-ky-so-phap-ly",
                name: "ThietLapKySoPhapLy",
                component: () => import("../pages/kySoPhapLy/thietLapKySo"),
            },
            {
                path: "/sig",
                name: "sig",
                component: () => import("../pages/kySoPhapLy/sig"),
            },
            {
                path: "/van-ban-noi-bo",
                name: "van-ban-noi-bo",
                component: () => import("../pages/vanBanNoiBo"),
            },
            {
                path: "/cong-van",
                name: "cong-van",
                component: () => import("../pages/congVan"),
            },
            {
                path: "/luu-cv-den",
                name: "cong-van-den",
                component: () => import("../pages/congVan/luuCVDen"),
            },
            {
                path: "/luu-cv-di",
                name: "cong-van-di",
                component: () => import("../pages/congVan/luuCVDi"),
            },
            {
                path: "/thong-tin-ky-so",
                name: "thong-tin-ky-so",
                component: () => import("../pages/kyso/thongTinKySo"),
            },
            {
                path: "/soan-van-ban-di/:id?",
                name: "soan-van-ban-di",
                component: () => import("../pages/vanbandi/soanvanban"),
            },
            {
                path: "/kspl-thiet-lap/:id?",
                name: "kspl-thietlap",
                component: () => import("../pages/kyso/kspl-thietlap"),
            },
            {
                path: "/ksnb-thiet-lap/:id?",
                name: "kspl-thietlap",
                component: () => import("../pages/kySoNoiBo/thietLapKySoNoiBo"),
            },

            {
                path: "/hop-thu/chi-tiet/:id",
                name: "Xem hộp thu",
                component: () => import("../pages/hopThu/detail"),
            },
            {
                path: "/hop-thu/soan-thu/:id?",
                name: "Soạn thư",
                component: () => import("../pages/hopThu/soanThu"),
            },
            {
                path: "/hop-thu/tra-loi/:id?",
                name: "tra-loi",
                component: () => import("../pages/hopThu/soanThu"),
            },
            {
                path: "/hop-thu/tra-loi-tat-ca/:id?",
                name: "tra-loi-tat-ca",
                component: () => import("../pages/hopThu/soanThu"),
            },
            {
                path: "/hop-thu/chuyen-tiep/:id?",
                name: "chuyen-tiep",
                component: () => import("../pages/hopThu/soanThu"),
            },
            {
                path: "/thong-bao-cap-bo",
                name: "thong-bao-cap-bo",
                component: () => import("../pages/thongBao/capBo"),
            },
            {
                path: "/thong-bao-cap-tinh",
                name: "thong-bao-cap-tinh",
                component: () => import("../pages/thongBao/capTinh"),
            },
            {
                path: "/thong-bao-cap-truong",
                name: "thong-bao-cap-truong",
                component: () => import("../pages/thongBao/capTruong"),
            },
            {
                path: "/merge-thongbao",
                name: "merge-thongbao",
                component: () => import("../pages/thongBao/mergeThongBao"),
            },
            {
                path: "/quan-tri-thong-bao",
                name: "quanTriThongBao",
                component: () => import("../pages/quanTriNoiDung/quanTriThongBao"),
            },
            {
                path: "/quan-tri-hop-thu",
                name: "quanTriHopThu",
                component: () => import("../pages/quanTriNoiDung/quanTriHopThu"),
            },
            {
                path: "/quan-tri-thong-bao-admin",
                name: "QuanTriThongBaoAdmin",
                component: () => import("../pages/quanTriNoiDung/QuanLyThongBao/mergeThongBao.vue"),
            },
            {
                path: "/thiet-lap-ky-thay",
                name: "ThietLapKyThay",
                component: () => import("../pages/thietLapKyThay"),
            },
            {
                path: "/map-status",
                name: "MapStatus",
                component: () => import("../pages/mapStatus"),
            },
            {
                path: "/thong-tin-lien-lac",
                name: "ThongTinLienLac",
                component: () => import("../pages/thongTinLienLac"),
            },
            {
                path: "/doi-mat-khau",
                name: "DoiMatKhau",
                component: () => import("../router/layouts/LayoutChangePassword"),
            },
            {
                path: "/privacy-aparking",
                name: "privacy-aparking",
                component: () => import("../pages/privary-aparking"),
            },
            {
                path: "/privacy",
                name: "privacy",
                component: () => import("../pages/privacy/privacy"),
            },
            {
                path: "/term-of-use",
                name: "term-of-use",
                component: () => import("../pages/privacy/term_of_use"),
            },
            {
                path: "/ios-app-connector",
                name: "ios_app_connector",
                // meta: {},
                component: () => import("../pages/iosManagement/index.vue"),
            },
            {
                path: "/ios-management",
                name: "ios-management",
                // meta: {},
                component: () => import("../pages/iosManagement/manage.vue"),
            },
            {
                path: "/quan-ly-cong-viec",
                name: "quan-ly-cong-viec",
                // meta: {},
                component: () => import("../pages/quangLyCongViec/index.vue"),
            },
            {
                path: "/quan-ly-cong-viec/nhom-cong-viec/:id?",
                name: "quan-ly-cong-viec/nhom-cong-viec",
                // meta: {},
                component: () => import("../pages/quangLyCongViec/soanNhomCongViec.vue"),
            },
            {
                path: "/tien-do-cong-viec/:id?",
                name: "tien-do-cong-viec",
                // meta: {},
                component: () => import("../pages/quangLyCongViec/tienDoCongViec.vue"),
            },
            {
                path: "/tien-do-cong-viec/:groupId?/cong-viec/:id?",
                name: "tien-do-cong-viec/cong-viec",
                // meta: {},
                component: () => import("../pages/quangLyCongViec/soanTienDoCongViec.vue"),
            },
            {
                path: "/tham-dinh-van-ban/:id?",
                name: "tham-dinh-van-ban",
                component: () => import("../pages/thamDinhVanBan/thamDinhVanBan.vue"),
            },
            {
                path: "/quan-ly-sinh-vien",
                name: "quan-ly-sinh-vien",
                component: () => import("../pages/quanLySinhVien/quanLySinhVien.vue"),
            },
            {
                path: "/dang-ky-doffice",
                name: "dang-ky-tai-khoan-doffice",
                component: () => import("../pages/dangKyTaiKhoan/index.vue"),
            },
            {
                path: "/quan-ly-dang-ky-doffice",
                name: "quan-ly-dang-ky-doffice",
                component: () => import("../pages/dangKyTaiKhoan/quanLyDangKyTaiKhoan.vue"),
            },
            {
                path: "/attendo/dashboard",
                name: "attendo-dashboard",
                component: () => import("../pages/webView/attendoWebView.vue"),
            },
        ]
    },
    {
        path: "/xac-nhan-ky-so",
        name: "Xác nhận ký số nội bộ",
        // meta: {},
        component: () => import("../pages/xacNhanKySo/pages"),
    },
    {
        path: "/xem-tep-tin/:id?",
        name: "Xem tệp tin",
        component: () => import("../pages/ShowPDF"),
    },
    {
        path: "/document-view/:id?",
        name: "Xem tệp tin",
        component: () => import("../pages/DocumentViewer"),
    },
]
